import React, { FC } from 'react';
import { Box, makeStyles, Theme, Typography } from '@material-ui/core';

export interface SliderCardProps {
  title: string;
  index?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 187,
    border: `1px solid ${theme.palette.secondary.light}`,
    padding: theme.spacing(11, 0, 8, 4),
    borderBottomColor: theme.palette.primary.main,
    borderBottomWidth: 2,
  },
  numberBox: {
    fontSize: 17,
    color: theme.palette.common.white,
    minWidth: 39,
    minHeight: 38,
    backgroundColor: theme.palette.primary.main,
    paddingTop: 8,
    top: 0,
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
    lineHeight: 1.3,
    maxWidth: 246,
  },
}));

const SliderCard: FC<SliderCardProps> = ({ title, index }) => {
  const classes = useStyles();
  return (
    <Box position="relative" className={classes.root} display="flex" flexDirection="column" justifyContent="center">
      <Box position="absolute" className={classes.numberBox}>
        <Typography align="center">0{index}</Typography>
      </Box>
      <Typography variant="h4" className={classes.title}>
        {title}
      </Typography>
    </Box>
  );
};

export default SliderCard;
